export const VERSION = 2;

const serviceWorkerBlacklist = [/^\/profile-creation(\/)?/, /^\/forgot-password(\/)?/, /^\/stop-page(\/)?/, /^\/(payment|cart)(\/)?/];

export const isBlacklisted = path => !!serviceWorkerBlacklist.filter(pattern => pattern.test(path)).length;
export const isLiteApp = () => window.app && typeof window.app.markLoginInApp === 'function';

export const shouldRegisterServiceworker = () => !isLiteApp() && !isBlacklisted(window.location.pathname);
